import React from 'react';
import moment from 'moment';

const itemShipper = ({type, item}) => {
    return(
        <div className="div-out-iac-ccsf mx-auto my-2" style={{ fontSize: '16px' }}>
            <h6>{type}</h6>
            <table className="table">
                <thead className="thead-light">
                    <tr>
                        <th scope="col">Approval #:</th>
                        <th scope="col">Certified Cargo Screening Facility Name:</th>
                        <th scope="col">Address:</th>
                        <th scope="col">CCSF Expiration:</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row" style={{backgroundColor: '#90ee90'}}>{item.approval_number}</th>
                        <td>{item.certified_cargo_screening_facility_name}</td>
                        <td>{item.street_address}, {item.city}, {item.state}</td>
                        <td style={{backgroundColor: `${item.valid ? 'white' : 'red'}`, color: `${item.valid ? '#037d50' : 'black'}`, fontWeight: 'bolder'}}>
                            {moment.utc(item.expiration_date).format('MM/DD/YYYY')}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}

export default itemShipper;